import { Button } from "@mui/material";
import React from "react";

const SSPCommonButton = ({ btnText, btnFunction, isMaintaince,isDisabled,type, loading, loadingText = "Loading..."  }) => {
  return (
    <Button
      type={type}
      sx={{
        color: "white",
        backgroundColor:isMaintaince?'#ABB8C3 !important': btnText === "Reset Filters" ? "#F4A100 !important" : "#0160F1 !important",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        padding: "0.5rem 1.125rem",
        fontSize: "0.875rem",
        borderRadius: "0.35rem",

        "&:hover": {
          backgroundColor: btnText === "Reset Filters" ? "#D19900 !important " : "darkblue !important",
        },
      }}
      onClick={() => btnFunction()}
      // disabled={loading}
      disabled={loading || isDisabled}
    >
      {loading ? loadingText  : btnText}
    </Button>
  );
};

export default SSPCommonButton;
